import { $actionEvent } from '../actions/actionEvent';
import { COLS_BAR_HEIGHT, ROWS_BAR_WIDTH } from './consts';
import { $highlight, $selections, setSelection } from './selection';
import { RectRange } from '@/model/range';
import type { Sheet } from '@/model/sheet';
import { useStore } from '@nanostores/react';
import { useEffect, useRef } from 'react';

export function SelectedCell({ sheet }: { sheet: Sheet }) {
  const divRef = useRef<HTMLDivElement>(null);
  const cellPos = useStore($highlight);
  const pos = sheet.getCellPos(cellPos);
  const size = sheet.getCellSize(cellPos);

  useEffect(() => {
    const unsub = $actionEvent.ons({
      highlight: ({ pos, dontClear }) => {
        $highlight.set(pos);
        if (!dontClear) setSelection(RectRange.point(pos));
        requestAnimationFrame(() => {
          divRef.current?.scrollIntoView({
            block: 'nearest',
            inline: 'nearest',
            behavior: 'smooth',
          });
        });
      },
      expandHighlight: ({ delta }) => {
        const selections = $selections.get();
        if (selections.length !== 1 || !selections[0]!.start.equals(cellPos)) {
          setSelection(new RectRange(cellPos, cellPos.add(delta)));
          return;
        }
        setSelection(
          new RectRange(cellPos, selections[0]!.end.add(delta).max(0)),
        );
      },
    });

    return () => {
      unsub();
    };
  });

  return (
    <>
      <div
        ref={divRef}
        className="pointer-events-none absolute border-3 border-green-800"
        style={{
          scrollMarginTop: COLS_BAR_HEIGHT,
          scrollMarginLeft: ROWS_BAR_WIDTH,
          top: pos.y,
          left: pos.x,
          width: size.x,
          height: size.y,
        }}
      ></div>
    </>
  );
}
